export { default } from './FavoritesForecast';
